import { audio } from "../audio/audio";
import { bump, fmtCompact } from "./kit";
import { resourceIconUrl } from "./portraits";
import { essenceIconUrl } from "./forgeArt";

/**
 * COLLECT on the chest stage (chests v8 wow pass): the loot card pays out. Coins (and Forge Essence) leave its pills in
 * a stream, arc over to wallet chips where COLLECT was and drop in with a clink each, the chips counting up as they land;
 * then `onDone`. The amounts are the chest's own (the caller banked them already): this is how the payment is shown.
 */
export interface PayoutAmounts { gold: number; essence?: number }

/** How many coins fly for an amount (more for more, 6–18), and the ms between two of them. */
export function coinsFor(amount: number): number { return Math.max(6, Math.min(18, Math.round(4 + Math.log10(Math.max(1, amount)) * 3))); }
export const COIN_GAP_MS = 55;
const FLIGHT_MS = 520;

export function payout(stage: HTMLElement, loot: HTMLElement | null, amounts: PayoutAmounts, motion: boolean, onDone: () => void): void {
  const flows = [{ kind: "gold", icon: resourceIconUrl("gold"), amount: amounts.gold, pill: ".pill.gold:not(.ess)" },
    ...(amounts.essence ? [{ kind: "ess", icon: essenceIconUrl(), amount: amounts.essence, pill: ".pill.ess" }] : [])].filter((f) => f.amount > 0);
  if (!motion || flows.length === 0 || !loot) { onDone(); return; }
  const wallet = document.createElement("div");
  wallet.className = "rs-wallet";
  wallet.innerHTML = flows.map((f) => `<span class="wchip ${f.kind}"><img src="${f.icon}" alt=""><b class="disp">0</b></span>`).join("");
  stage.append(wallet);
  wallet.animate([{ transform: "translate(-50%, 20px)", opacity: 0 }, { transform: "translate(-50%, 0)", opacity: 1 }], { duration: 220, easing: "ease-out", fill: "both" });
  const host = stage.getBoundingClientRect();
  let end = 0;
  flows.forEach((f, fi) => {
    const chip = wallet.querySelectorAll<HTMLElement>(".wchip")[fi];
    const num = chip.querySelector("b")!;
    const src = (loot.querySelector<HTMLElement>(f.pill) ?? loot).getBoundingClientRect();
    const n = coinsFor(f.amount);
    let shown = 0;
    for (let i = 0; i < n; i++) {
      const delay = 240 + fi * 160 + i * COIN_GAP_MS;
      end = Math.max(end, delay + FLIGHT_MS);
      window.setTimeout(() => {
        if (!stage.isConnected) return;
        const dst = chip.getBoundingClientRect();
        const c = document.createElement("img");
        c.className = "rs-coin";
        c.src = f.icon;
        stage.append(c);
        const x0 = src.left + src.width * (0.25 + 0.5 * Math.random()) - host.left, y0 = src.top + src.height / 2 - host.top;
        const x1 = dst.left + 14 - host.left, y1 = dst.top + dst.height / 2 - host.top;
        const mx = (x0 + x1) / 2 + (Math.random() - 0.5) * 120, my = Math.min(y0, y1) - 60 - Math.random() * 60;
        c.animate([
          { transform: `translate(${x0}px, ${y0}px) scale(.6)`, opacity: 0 },
          { transform: `translate(${mx}px, ${my}px) scale(1.15)`, opacity: 1, offset: 0.45 },
          { transform: `translate(${x1}px, ${y1}px) scale(.8)`, opacity: 1 },
        ], { duration: FLIGHT_MS, easing: "cubic-bezier(.45,.05,.55,.95)", fill: "both" }).onfinish = () => {
          c.remove();
          shown = i === n - 1 ? f.amount : Math.round((f.amount * (i + 1)) / n);
          num.textContent = fmtCompact(shown);
          bump(chip, 1.12, 120);
          audio.play("chestCollect", 0, 1 + 0.02 * i);
        };
      }, delay);
    }
  });
  window.setTimeout(() => { if (stage.isConnected) onDone(); }, end + 420);
}
